import React from 'react'
import { Radio } from 'antd'
import * as _ from 'lodash'
import { agreementState, purposeState, userType } from './constants'

export const isEmptyObject = obj => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object
}

const getStateLabel = (key, states) => {
  return Object.values(states).find(el => el.key === key).label
}

export const getAgreementStateLabel = key => {
  return key ? getStateLabel(key, agreementState) : null //Object.values(agreementState).find(el => el.key === key).label
}

export const getPurposeStateLabel = key => {
  return key ? getStateLabel(key, purposeState) : null //Object.values(purposeState).find(el => el.key === key).label
}

export const renderRadios = obj => {
  const radios = []
  Object.keys(obj).forEach(key => {
    radios.push(
      <Radio key={key} value={key}>
        {obj[key]}
      </Radio>
    )
}
  )
  return radios
}

export const getStoresFromAgreement = agreement => {
  let agreementStores = [];

  if (Array.isArray(agreement.agreementDetails)) {
    for (let agreementDetail of agreement.agreementDetails) {
      if (!Array.isArray(agreementDetail.proposals)) {
        continue;
      }

      for (let agreementProposal of agreementDetail.proposals) {
        agreementStores.push({
          storeCode: agreementProposal.storeId,
          storeDesc: agreementProposal.storeName
        });
      }
    }
  }

  agreementStores = _.orderBy(_.uniq(agreementStores), ['storeCode'], ['asc']);

  return agreementStores;
};

export const getStatesBasedOnUserType = type => {
  let allowedStates = [];

  if (type === userType.PM.key) {
    allowedStates = [0, 1, 2, 3, 4, 5, 6];
  } else if (type === userType.S.key) {
    allowedStates = [1, 2, 3, 4, 5, 6];
  } else if (type === userType.AM.key) {
    allowedStates = [0, 1, 2, 3];
  }

  const allowedStateCodes = [];

  for (let allowedState of allowedStates) {
    allowedStateCodes.push(agreementState[allowedState].key);
  }

  if (allowedStateCodes.length === 0) {
    allowedStateCodes.push('NA');
  }

  return allowedStateCodes.join(',');
};

export const purposePermission = (currState, user) => {
  let canEdit = false, canView = false, fields = [], currentQuantity, prevQuantity = 'acceptedStock';
  switch (currState) {
    case 'OPEN_WAITING_AREA_MANAGER' :
      //T3-1
      canEdit = user.type === userType.AM.key
      canView = [userType.AM.key, userType.SC.key, userType.PM.key, userType.S.key, userType.FIN.key].includes(user.type)
      fields.push({ column: 'realStock', edit: user.type === userType.AM.key, hide: user.type !== userType.AM.key })
      currentQuantity = 'realStock'
      prevQuantity = 'acceptedStock';
      break
    case 'CLOSED_REJECTED_SUPPLIER':
      //Rifiutato dal fornitore
      canView = [userType.AM.key, userType.SC.key, userType.PM.key, userType.S.key, userType.FIN.key].includes(user.type)
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' }, { column: 'shippedStock' }, { column: 'deliveredStock' })
      currentQuantity = 'deliveredStock'
      prevQuantity = 'shippedStock';
      break
    case 'APPROVED_WAITING_SUPPLIER':
      //T3-2 T4-1
      canEdit = user.type === userType.S.key
      canView = [userType.AM.key, userType.SC.key, userType.PM.key, userType.S.key, userType.FIN.key].includes(user.type)
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock', edit: user.type === userType.S.key, hide: user.type !== userType.S.key })
      currentQuantity = 'withdrawnStock'
      prevQuantity = 'realStock';
      break
    case 'APPROVED_WAITING_AREA_MANAGER':
      //T4-2 T5-1
      canView = [userType.AM.key, userType.SC.key, userType.PM.key, userType.S.key, userType.FIN.key].includes(user.type)
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' })
      currentQuantity = 'withdrawnStock'
      prevQuantity = 'realStock';
      break
    case 'FORWARDED_SUPPLY_CHAIN':
      //T5-2 T6-1
      canEdit = user.type === userType.SC.key
      canView = [userType.SC.key, userType.AM.key, userType.PM.key, userType.S.key, userType.FIN.key].includes(user.type);
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' }, {
        column: 'shippedStock',
        edit: user.type === userType.SC.key,
        hide: user.type !== userType.SC.key
      }, { column: 'supplyChainChangeReason', edit: user.type === userType.SC.key, hide: user.type !== userType.SC.key})
      currentQuantity = 'shippedStock'
      prevQuantity = 'withdrawnStock';
      break
    case 'FORWARDED_SUPPLIER':
      //T6-2 T7-1
      canEdit = user.type === userType.S.key
      canView = user.type === userType.SC.key || user.type === userType.AM.key || userType.PM.key || user.type === userType.S.key || user.type === userType.FIN.key
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' }, { column: 'shippedStock' }, {column: 'supplyChainChangeReason'}, {
        column: 'deliveredStock',
        edit: user.type === userType.S.key,
        hide: user.type !== userType.S.key
      })
      currentQuantity = 'deliveredStock'
      prevQuantity = 'shippedStock';
      break
    case 'RECEIVED_SUPPLIER':
      //T7-2
      canView = user.type === userType.SC.key || user.type === userType.AM.key || userType.PM.key || user.type === userType.S.key || user.type === userType.FIN.key
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' }, { column: 'shippedStock' }, {column: 'supplyChainChangeReason'}, { column: 'deliveredStock' })
      currentQuantity = 'deliveredStock'
      prevQuantity = 'shippedStock';
      break
    case 'CLOSED_REJECTED_AREA_MANAGER':
      //Rifiutata dal capo settore
      canView = user.type === userType.SC.key || user.type === userType.AM.key || userType.PM.key || user.type === userType.S.key || user.type === userType.FIN.key
      fields.push({ column: 'realStock' }, { column: 'withdrawnStock' })
      currentQuantity = 'withdrawnStock'
      prevQuantity = 'realStock';
      break

    default:
      break
  }
  return { canEdit, canView, fields, currentQuantity, prevQuantity }
}

export const getCookie = cname => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const decodedCookieSplit = decodedCookie.split(';');

  for (let a = 0; a < decodedCookieSplit.length; a++) {
    let c = decodedCookieSplit[a];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
}

export const setCookie = (cname, cvalue, days = 365) => {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;

  document.cookie = cname + "=" + cvalue + ";" + expires + "; path=/";
};

export const getSupplierFromToken = token => {
  if (_.isNil(token)) {
    return null;
  }

  const s = token.split('.');
  let data = null;

  try {
    data = JSON.parse(atob(s[1]));
  } catch (e) {
    console.error(e);
  }

  return data;
}

export const getMainStoreFromUser = user => {
  const stores = _.filter(_.get(user, ['data', 'data', 'storeIds'], []), storeId => storeId !== 0);

  return _.first(stores);
}



// WEBPACK FOOTER //
// ./src/common/utils.js